import _ from "lodash";
import ls from "../Localization";

export function getErrors(errors) {
	const toReturn = {};
	for (const error of _.toPairs(errors)) {
		toReturn[error[0]] = ls[error[1]] || error[1];
	}
	return toReturn;
}